<section class="mx-auto max-w-screen-sm text-center">
    <h1 class="mb-4 text-7xl font-extrabold lg:text-9xl text-dark-gray2">404</h1>
    <p class="mb-4 text-3xl font-bold text-dark-gray2 md:text-4xl">Something's
        missing.</p>
    <p class="mb-4 text-lg text-dark-gray2">Sorry, we can't find that page. You'll find lots to explore on the
        home page. </p>
    <button class="bg-teal2 px-5 py-3 font-medium border border-light-gray1 rounded-lg" routerLink="/">Go to
        home page</button>
</section>